import { localSiteHost } from "../../utils/sharedUtilities";

function Footer(props) {
    const config = props.config;
    const scripts = config?.resources?.scripts ?? [];
    return (
        <>
            {(!config.showFooterMessage ? '' : (
                <div className="footer-message">
                    <span>{config.footerMessage}</span>
                </div>
            ))}

            {scripts.map(x =>
                <script key={x} src={x} type="text/javascript"></script>
            )}

            <script src={`${localSiteHost}/js/site.js`} type="text/javascript"></script>
            <input type="hidden" id="apiAddress" value="/api/" />
        </>
    );
}

export default Footer;